
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/[lang]/participate/tv-channels",
      function () {
        return require("private-next-pages/mahashivratri/[lang]/participate/tv-channels/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/[lang]/participate/tv-channels"])
      });
    }
  